var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 40.986,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-90 0 40.986)",
    fill: "#383C42"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.407 19.916a.75.75 0 00-.562.302l-3.5 4.721a.75.75 0 00.648 1.199l2.63-.15.042.753a4.143 4.143 0 004.366 3.896l8.456-.482c.568 1.493 2.036 2.522 3.715 2.427a3.763 3.763 0 00-.428-7.514c-1.678.097-3.061 1.287-3.414 2.834l-8.456.481a1.883 1.883 0 01-1.985-1.771l-.042-.751 2.63-.15a.753.753 0 00.507-1.267L13 20.15a.748.748 0 00-.594-.234zM27.9 27.324a1.507 1.507 0 011.589 1.417 1.507 1.507 0 01-1.417 1.589 1.507 1.507 0 01-1.589-1.418 1.507 1.507 0 011.417-1.588zM8.265 13.364a3.763 3.763 0 003.97 3.542c1.68-.096 3.022-1.285 3.416-2.833l8.456-.482a1.883 1.883 0 011.985 1.771l.043.751-2.63.15A.754.754 0 0023 17.53l4.013 4.294a.751.751 0 001.153-.066l3.5-4.722a.747.747 0 00.059-.806.754.754 0 00-.706-.394l-2.63.15-.042-.751a4.143 4.143 0 00-4.367-3.897l-8.457.482c-.567-1.493-2.036-2.522-3.715-2.427-2.075.161-3.66 1.897-3.542 3.971zm5.259-.297a1.507 1.507 0 01-1.417 1.588 1.507 1.507 0 01-1.588-1.417 1.507 1.507 0 011.417-1.588 1.507 1.507 0 011.588 1.417z",
    fill: "#fff"
  })));
}
export default SvgCodeCompare;